module.exports = __webpack_public_path__ + "img/18.795c6bcb.png";